/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Changes_TitleInputs */

const en_us2_workout_after_changes_title = /** @type {(inputs: Workout_After_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next workout`)
};

const pt_br2_workout_after_changes_title = /** @type {(inputs: Workout_After_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No próximo treino`)
};

const es_419_workout_after_changes_title = /** @type {(inputs: Workout_After_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo entrenamiento`)
};

const pt_pt2_workout_after_changes_title = /** @type {(inputs: Workout_After_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No próximo treino`)
};

const fr_fr2_workout_after_changes_title = /** @type {(inputs: Workout_After_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prochaine séance`)
};

const de_de2_workout_after_changes_title = /** @type {(inputs: Workout_After_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Training`)
};

const it_it2_workout_after_changes_title = /** @type {(inputs: Workout_After_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel prossimo allenamento`)
};

/**
* | output |
* | --- |
* | "Next workout" |
*
* @param {Workout_After_Changes_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_changes_title = /** @type {((inputs?: Workout_After_Changes_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Changes_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_changes_title(inputs)
	if (locale === "es-419") return es_419_workout_after_changes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_changes_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_changes_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_changes_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_changes_title(inputs)
	return en_us2_workout_after_changes_title(inputs)
});
export { workout_after_changes_title as "workout-after.changes_title" }